import React from 'react';
import './PrivacyPolicyPage.scss';

const PrivacyPolicy = () => {
  return (
    <main className="privacy-policy">
      <section className="container">
        <h1>Privacy Policy</h1>
        <p>Your privacy is important to us. It is Canadian Broadway's policy to respect your privacy regarding any information we may collect from you across our website,  https://canadatheatre.ca.</p>
        
        <h2>1. Information we collect</h2>
        <p>We only collect information revelvant to the voting process process and the contestant portfolio that is displayed on the site. No other information is collected. We do not have access to information that you do not provide directly to the site.</p>
        
        <h2>2. Security</h2>
        <p>We take reasonable measures to protect your personal information from unauthorized access, use, or disclosure.</p>
        
        <h2>Contact Us</h2>
        <p>If you have any questions about our Privacy Policy, please contact us at  banerproductions@gmail.com.</p>
      </section>
    </main>
  );
};

export default PrivacyPolicy;
